import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type ParcelCardDeleteModalState = boolean;

const initialParcelCardDeleteModalState: ParcelCardDeleteModalState = false;

const parcelCardDeleteModalSlice = createSlice({
  name: "ParcelCardDeleteModal",
  initialState: initialParcelCardDeleteModalState,
  reducers: {
    openDeleteCardModalAction: () => {
      return true;
    },
    closeDeleteModalAction: () => {
      return false;
    },
  },
});

const parcelCardDeleteModalBaseSelector = createBaseSelector(parcelCardDeleteModalSlice);

registerSlice([parcelCardDeleteModalSlice]);

export const parcelCardDeleteModalStore = {
  actions: parcelCardDeleteModalSlice.actions,
  selectors: {
    parcelCardDeleteModal: createSelector(parcelCardDeleteModalBaseSelector, (s) => s),
  },
};
